import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { Globals } from '../../_models/globals';

import { NotificationService } from '../../_services/notification.service';
import { SuportGridviewSort, SupportGridview, SupportGridviewTableBodyCell, SupportGridviewTemplateCell } from '../_models/supportGridview';
import { DisputeManagementService } from './dispute-management.service';
import { SupportDisputeDetailComponent } from '../_componentes/dispute-detail/dispute-detail.component';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { DisputeManagementData } from './_models/disputeManagementData';

declare const $: any;
declare const isEmpty: any;

@Component({
    selector: 'app-dispute-management', templateUrl: './dispute-management.component.html', styleUrls: ['./dispute-management.component.scss'],
    standalone: false
})
export class SupportDisputeManagementComponent implements AfterViewInit, OnDestroy, OnInit {
    @ViewChild('infoTemplate') infoTemplate: TemplateRef<any>;
    @ViewChild('templateDisputeDetail') public disputeDetailModal: SupportDisputeDetailComponent;

    private _sortSubscription: Subscription;
    private hasFiltered: boolean = false;

    public filter: string = '';
    public config: SupportGridview = new SupportGridview();
    public templatesArray: SupportGridviewTemplateCell[] = [];

    public disputeManagementDataList: DisputeManagementData[]

    constructor(private disputeManagementService: DisputeManagementService, private notificationService: NotificationService, private globals: Globals, private ngxLoader: NgxUiLoaderService) {}

    ngOnInit(): void {
        this._sortSubscription = this.disputeManagementService.sortDataValue$.subscribe(value => this.config.sort = value);

        this.config.set({
            actions: {
                approve: { enable: true, confirmationText: 'support.dispute-management.table.icon-button.approve.confirm', tooltipText: 'support.dispute-management.table.icon-button.approve.tooltip', type: 'icon' },
                edit: { enable: false },
                reject: { enable: true, tooltipText: 'support.dispute-management.table.icon-button.reject.tooltip', type: 'icon' },
            },
            emptyText: { isHtml: false, value: 'support.dispute-management.table.empty.before-search' },
            icon: { iconName: 'search', tooltipText: 'support.dispute-management.table.icon.details.tooltip' },
            list: [],
            sort: this.disputeManagementService.getSortDataValue(),
            table: {
                body: [
                    new SupportGridviewTableBodyCell('col col-0-25 text-center', 'reason', 'html', null, 'infoTemplate'),
                    new SupportGridviewTableBodyCell('col-1 truncate-gridview', 'supplierName', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col-1 truncate-gridview', 'repairerName', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col-2 truncate-gridview', 'vehicle', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('col-2 truncate-gridview', 'partDescription', 'string', null, null, true),
                    new SupportGridviewTableBodyCell('text-end', 'disputedValue', 'currency'),
                    new SupportGridviewTableBodyCell('text-center', 'creationDate', 'date')
                ],
                header: [
                    { className: 'col col-0-25 text-center', value: 'support.dispute-management.table.title.info' },
                    { className: 'col', sortName: 'supplierName', value: 'support.dispute-management.table.title.supplier-name' },
                    { className: 'col', sortName: 'repairerName', value: 'support.dispute-management.table.title.repairer-name' },
                    { className: 'col col-2', sortName: 'vehicle', value: 'support.dispute-management.table.title.vehicle' },
                    { className: 'col col-2', sortName: 'partDescription', value: 'support.dispute-management.table.title.part' },
                    { className: 'col text-end', sortName: 'disputedValue', value: 'support.dispute-management.table.title.disbute-value' },
                    { className: 'col text-center', sortName: 'creationDate', value: 'support.dispute-management.table.title.creation-date' },
                    { className: 'col col-0-5', value: '' }
                ],
            }
        });

        this.loadScreen();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.templatesArray = [
                { name: 'infoTemplate', template: this.infoTemplate }
            ];
        })
    }

    ngOnDestroy(): void {
        if (!this._sortSubscription?.closed)
            this._sortSubscription.unsubscribe();
    }

    approveDispute(dispute: DisputeManagementData) {
        this.ngxLoader.startLoader('loader-principal');

        this.disputeManagementService.approveDispute(dispute.disputeId).subscribe({
            next: () => {
                this.notificationService.showSuccessToastr('support.dispute-management.messages.success.approve', { translateMessage: true });
                this.loadScreen();
            },
            error: () => {
                this.notificationService.showErrorToastr('support.dispute-management.messages.error.approve', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }


    filterBillingSupplierDataList() {
        if (isEmpty(this.disputeManagementDataList))
            return [];

        if (isEmpty(this.filter))
            return this.disputeManagementDataList;

        var term: string = this.filter.toLowerCase();

        return this.disputeManagementDataList.filter(holding => {
            return holding.supplierName.toLowerCase().startsWith(term)
                || holding.repairerName.toLowerCase().startsWith(term)
                || holding.vehicle.toLowerCase().includes(term)
                || holding.partDescription.toLowerCase().includes(term);
        });
    }

    loadScreen() {
        this.ngxLoader.startLoader('loader-principal');

        this.disputeManagementService.getAll().subscribe({
            next: (response: ApiResponseModel<DisputeManagementData[]>) => {
                this.disputeManagementDataList = response.result
                this.setSupportGridViewData();

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: () => {
                this.notificationService.showErrorToastr('support.dispute-management.messages.error.load', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    openDetail(dispute: DisputeManagementData) {
        this.disputeDetailModal.open(dispute.orderInfoId, dispute.vehicle);
    }

    async rejectDispute(dispute: DisputeManagementData) {
        const params: SweetAlertParams = {
            input: 'textarea',
            title: 'support.dispute-management.table.icon-button.reject.confirm-modal.title',
            inputPlaceholder: 'elemento.generico-input.placeholder'
        }

        await this.notificationService.showConfirm(params).then((result) => {
            if (!result.isConfirmed)
                return;

            const reason = $('.swal2-textarea').val().toString().trim();

            if (isEmpty(reason)) {
                this.notificationService.showErrorToastr('support.dispute-management.messages.error.reject-reason', { translateMessage: true });
                return;
            }

            this.rejectDisputeExecute(dispute, reason);
        });
    }

    private rejectDisputeExecute(dispute: DisputeManagementData, reason: string) {
        this.ngxLoader.startLoader('loader-principal');

        this.disputeManagementService.rejectDispute(dispute.disputeId, reason).subscribe({
            next: () => {
                this.notificationService.showSuccessToastr('support.dispute-management.messages.success.reject', { translateMessage: true });
                this.loadScreen();
            },
            error: () => {
                this.notificationService.showErrorToastr('support.dispute-management.messages.error.reject', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    onSearch($event: string) {
        if (isEmpty(this.disputeManagementDataList))
            return [];

        this.filter = $event;
        this.config.emptyText = { isHtml: false, value: 'support.dispute-management.table.empty.' + (isEmpty(this.hasFiltered) ? 'before-search' : 'after-search') },

        this.setSupportGridViewData();
    }

    onSort(sortData: SuportGridviewSort) {
        this.disputeManagementService.setSortDataValue(sortData);
    }

    setSupportGridViewData() {
        this.config.list = this.filterBillingSupplierDataList();
    }
}
